import { IModel, TabularTypeDataset } from 'shell-models-lib';
import { Metamodel } from '../base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { PostgreSqlV2LinkedService } from '../linkedservice/postgre-sql-v2.linkedservice';

@Metamodel.model({
    name: __IS_FABRIC_DPE__ ? adfModelTypeMap.postgreSql.datasetType : adfModelTypeMap.postgreSqlV2.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.PostgreSql_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.PostgreSql_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: PostgreSqlV2LinkedService.MODEL // Linked service redefined
        }
    }
})
export class PostgreSqlV2Dataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
}
